<template>
  <ul :class="$style.reward_box">
    <li v-for="reward of rewardList" :key="reward.title" :class="reward.is_status ? $style.active : $style.coming_soon">
      <AtomsConsumerLink v-if="reward.url" :url="reward.url">
        <div :class="$style.title_box">
          <h5>{{ reward.title }}</h5>
          <svg v-if="reward.is_status" width="30" height="30" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" stroke="#BBCBE1" stroke-width="5" transform="rotate(180 25 25)">
              <line x1="40" y1="25" x2="10" y2="25" />
              <polyline points="20,15 10,25 20,35" />
            </g>
          </svg>
        </div>
        <p>
          <template v-if="reward.exchange_coupon">
            貯まった特典交換マイルは、最大{{ reward.mile?.toLocaleString() }}
            マイルまで同じ金額のクーポンに交換ができます。
          </template>
          <span v-else>{{ reward.description }}</span>
        </p>
      </AtomsConsumerLink>
      <template v-else>
        <div :class="$style.title_box">
          <h5>{{ reward.title }}</h5>
          <svg v-if="reward.is_status" width="30" height="30" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" stroke="#BBCBE1" stroke-width="5" transform="rotate(180 25 25)">
              <line x1="40" y1="25" x2="10" y2="25" />
              <polyline points="20,15 10,25 20,35" />
            </g>
          </svg>
        </div>
        <p>
          <template v-if="reward.is_status">
            貯まった特典交換マイルは、最大{{ reward.mile?.toLocaleString() }}
            マイルまで同じ金額のクーポンに交換ができます。
          </template>
          <span v-else>{{ reward.description }}</span>
        </p>
      </template>
    </li>
  </ul>
</template>

<script lang="ts" setup>
type Reward = {
  title: string
  description?: string
  mile?: number
  is_status: boolean
  url?: string
  exchange_coupon?: boolean
}
const rewardList: Reward[] = [
  {
    title: "マイルをクーポンに交換する",
    mile: 30000,
    is_status: true,
    url: "/mypage/coupons/exchange",
    exchange_coupon: true,
  },
  {
    title: "マイルを使って抽選に応募する",
    description:
      "貯まった特典交換マイルを抽選イベントの応募に使用することができます。 ※応募に必要なマイル数は抽選ごとに異なります",
    is_status: true,
    url: "/mypage/events",
  },
]
</script>

<style scoped module lang="scss">
.reward_box {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 44px;
  h5 {
    @include main-font;
    color: $primary;
    font-size: $font-size-15;
  }
  > li {
    padding: 1rem;
    border: 1px solid $primary-20;
    border-radius: 10px;
    &.coming_soon {
      background-color: #f4f4f4;
    }

    .title_box {
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>
